module.exports = __webpack_public_path__ + "img/crossSelect.b8b8e4f4.svg";